export default "__VITE_ASSET__ChUceydr__"